import React from 'react'
import { Instagram, Linkedin, Facebook } from 'lucide-react'
import { SOCIAL_LINKS, COMPANY_INFO, IMAGES, NAV_LINKS } from '../constants'

const iconMap: { [key: string]: React.ReactNode } = {
  instagram: <Instagram className="h-5 w-5" />,
  linkedin: <Linkedin className="h-5 w-5" />,
  facebook: <Facebook className="h-5 w-5" />,
}

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-primary py-10 text-white" role="contentinfo">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="mb-8 text-center">
          <img
            src={IMAGES.logoWhite}
            alt={`${COMPANY_INFO.name} Logo`}
            className="mx-auto mb-4 h-10 w-auto"
          />
          <p className="mx-auto mb-5 max-w-2xl leading-relaxed text-gray-300">
            Bavarian Real Estate — Asesoría inmobiliaria e inversión en República Dominicana.
          </p>

          {/* Social Links */}
          <div className="mb-5 flex justify-center gap-4">
            {SOCIAL_LINKS.map((social) => (
              <a
                key={social.platform}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-primary"
                aria-label={`Visitar ${social.platform}`}
              >
                {iconMap[social.icon]}
              </a>
            ))}
          </div>

          {/* Quick Links */}
          <div className="mb-5 flex flex-wrap justify-center gap-x-6 gap-y-2">
            {NAV_LINKS.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className="rounded text-gray-300 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Contact Info */}
          <div className="text-gray-300">
            <p>
              <a
                href={`mailto:${COMPANY_INFO.email}`}
                className="rounded transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
              >
                {COMPANY_INFO.email}
              </a>
              {' · '}
              <a
                href={`tel:${COMPANY_INFO.phoneHref}`}
                className="rounded transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
              >
                {COMPANY_INFO.phone}
              </a>
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-5 text-center sm:flex-row sm:text-left">
          <p className="text-sm text-gray-400">
            {currentYear} {COMPANY_INFO.name}. Todos los derechos reservados.
          </p>
          <a
            href="https://www.grwestate.com/"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-3 text-sm text-gray-400 transition-colors hover:text-white"
            aria-label="Sitio web desarrollado por GrowthEstate"
          >
            <span>Sitio web desarrollado por</span>
            <img
              src="/growthEstate-blanco.svg"
              alt="GrowthEstate"
              className="h-6 w-auto object-contain opacity-90 transition-opacity hover:opacity-100"
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
